import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getCustomerUserMeter(myPage) {
  return request({
    url: cmsServerContext + '/CustomerUserMeter/getCustomerUserMeterByPage',
    method: 'post',
    data: myPage
  })
}

export function saveMeterInfo(condition) {
  return request({
    url: cmsServerContext + '/Meter/saveMeterInfo',
    method: 'post',
    data: condition
  })
}

export function fetchMetersNotInUser(customerId) {
  return request({
    url: cmsServerContext + '/Meter/getMetersNotInUser/' + customerId,
    method: 'get'
  })
}

export function saveCustomerUserMeter(customerUserMeter) {
  return request({
    url: cmsServerContext + '/CustomerUserMeter/saveCustomerUserMeter',
    method: 'post',
    data: customerUserMeter
  })
}

export function deleteUserMeter(meter) {
  return request({
    url: cmsServerContext + '/CustomerUserMeter/deleteCustomerUserMeter',
    method: 'post',
    data: meter
  })
}

export function openningAccount(condition) {
  return request({
    url: cmsServerContext + '/dasApi/openAnAccount',
    method: 'post',
    data: condition
  })
}

export function stoppingAccount(condition) {
  return request({
    url: cmsServerContext + '/dasApi/stopAnAccount',
    method: 'post',
    data: condition
  })
}

export function amountSetting(condition) {
  return request({
    url: cmsServerContext + '/dasApi/amountSetting',
    method: 'post',
    data: condition
  })
}

export function rateSetting(condition) {
  return request({
    url: cmsServerContext + '/dasApi/rateSetting',
    method: 'post',
    data: condition
  })
}

export function batchConfig(customerId,list) {
  return request({
    url: cmsServerContext + '/CustomerUserMeter/saveBatchCustomerUserMeterRelation/' + customerId,
    method: 'post',
    data: list
  })
}